import { render, staticRenderFns } from "./Spirometry.vue?vue&type=template&id=3c8297f0"
import script from "./Spirometry.vue?vue&type=script&lang=js"
export * from "./Spirometry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports